import projectOne from "../../assets/project-1.png";
import projectTwo from "../../assets/project-2.png";
import projectThree from "../../assets/project-3.png";

const projects = {
  1: {
    title: "Blog Site",
    image: projectOne,
    description: (
      <>
        <p>
          A simple blog site built with MERN stack. Users can register, login,
          create, edit and delete posts. The site is responsive and mobile
          friendly.
        </p>
      </>
    ),
    github: "https://github.com/LomiaW",
    demo: "https://troubled-ox-robe.cyclic.app/blog",
  },
  2: {
    title: "Food Online Store",
    image: projectTwo,
    description: (
      <>
        <p>
          A simple online store built with JavaScript, HTML and the DOM. 
          Users can browse through the menu. This website is built with dynamic web content.
        </p>
      </>
    ),
    github: "https://github.com/LomiaW",
    demo: "https://netlify.com",
  },
  3: {
    title: "Food Delivery App",
    image: projectThree,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </>
    ),
    github: "https://github.com/LomiaW",
    demo: "https://netlify.com",
  },
};

export default projects;
